import { render, staticRenderFns } from "./ComponentGallery.vue?vue&type=template&id=47ac36f4&scoped=true"
import script from "./ComponentGallery.vue?vue&type=script&lang=js"
export * from "./ComponentGallery.vue?vue&type=script&lang=js"
import style0 from "./ComponentGallery.vue?vue&type=style&index=0&id=47ac36f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac36f4",
  null
  
)

export default component.exports